import { ChangeDetectorRef, Component, Inject, inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CargaService } from 'src/app/services/CargaService/carga.service';

import { PatioItem } from '../listagem-parametrizacao/listagem-parametrizacao.component';
import { firstValueFrom } from 'rxjs';
import { DestinatarioService } from 'src/app/services/DestinatarioService/destinatario.service';
import { sortSelectOptions } from 'src/app/core/utils/sort-select-options';
export type PatioFormMode = 'create' | 'edit';
type DialogData = {
  item?: Partial<PatioItem>;
  mode: PatioFormMode;
};
@Component({
  selector: 'app-patio-form-modal',
  templateUrl: './patio-form-modal.component.html',
  styleUrl: './patio-form-modal.component.scss'
})
export class PatioFormModalComponent implements OnInit {
  destinatarioService = inject(DestinatarioService);
  cargaService = inject(CargaService);
  private initialFkCrga = 0;
   private initialFkDtnr = 0;
  cargaOptions: { name: string; value: number }[] = [];
  destinatarioOptions: { name: string; value: number }[] = [];

  readonly periodoPorTurno: Record<number, string> = {
    0: '07:00 - 15:59',
    1: '16:00 - 23:59',
    2: '00:00 - 06:59'
  };

  get title(): string {
    return this.data.mode === 'create' ? 'Cadastrar pátio' : 'Edição de turno';
  }
form = this.fb.group({
    PK_PTIO: [0, { nonNullable: true }],
    NU_TRNO: [0, { nonNullable: true, validators: [Validators.required] }],
    QT_CAPA: [
      0,
      {
        nonNullable: true,
        validators: [Validators.required, Validators.min(0)]
      }
    ],
    QT_AGND: [
      0,
      {
        nonNullable: true,
        validators: [Validators.required, Validators.min(0)]
      }
    ],
    FK_CRGA: [
      0,
      {
        nonNullable: true,
        validators: [Validators.required, Validators.min(1)]
      }
    ],
    FK_DTNR: [0, { nonNullable: true }]
  });

  constructor(
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    private dialogRef: MatDialogRef<PatioFormModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    const item = data.item ?? {};
if (this.data.mode === 'edit') {
  this.form.controls.NU_TRNO.disable({ emitEvent: false });
  this.form.controls.FK_CRGA.disable({ emitEvent: false });
}

this.form.patchValue({
  PK_PTIO: (item as any).PK_PTIO ?? 0,
  NU_TRNO: Number(item.NU_TRNO ?? 0),
  QT_CAPA: Number(item.QT_CAPA ?? 0),
  QT_AGND: Number(item.QT_AGND ?? 0),
  FK_CRGA: Number((item as any).FK_CRGA ?? 0),
  FK_DTNR: Number((item as any).FK_DTNR ?? 0)
});

this.initialFkCrga = Number((item as any).FK_CRGA ?? 0);
this.initialFkDtnr = Number((item as any).FK_DTNR ?? 0);
  }

  async ngOnInit(): Promise<void> {
    await this.getCarga();
    await this.getDestinatario();
    
  }

  private async getCarga(): Promise<void> {
    try {
      const response = await firstValueFrom(this.cargaService.GetCarga());

      this.cargaOptions = sortSelectOptions(
        (response ?? []).map((t: any) => ({
          name: t.TX_CRGA,
          value: t.PK_CRGA
        }))
      );

      if (this.data.mode === 'edit' && this.initialFkCrga) {
        setTimeout(() => {
          this.form.patchValue({
            FK_CRGA: this.initialFkCrga
          });
        });
      }
    } catch (e) {
      console.error('Erro ao buscar cargas:', e);
      this.cargaOptions = [];
    }
  }
   private async getDestinatario(): Promise<void> {
    try {
      const response = await firstValueFrom(
        this.destinatarioService.getDestinatarios()
      );

      this.destinatarioOptions = sortSelectOptions(
        (response?.Destinatarios ?? []).map((t: any) => ({
          name: t.NM_DTNR,
          value: t.PK_DTNR
        }))
      );

      if (this.data.mode === 'edit' && this.initialFkDtnr) {
        setTimeout(() => {
          this.form.patchValue({
            FK_DTNR: this.initialFkDtnr
          });
        });
      }
    } catch (e) {
      console.error('Erro ao buscar destinatários:', e);
      this.destinatarioOptions = [];
    }
  }

  get periodoAtual(): string {
    const turno = this.form.controls.NU_TRNO.value;
    return this.periodoPorTurno[turno!] ?? '--';
  }

  close(): void {
    this.dialogRef.close(null);
  }

  save(): void {
    const fkCrga = Number(this.form.controls.FK_CRGA.value);
    if (fkCrga <= 0) {
      this.form.controls.FK_CRGA.markAsTouched();
      return;
    }

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

  const rawValue = this.form.getRawValue();
  console.log('PATIO MODAL RAW VALUE =>', rawValue);

  this.dialogRef.close({
    mode: this.data.mode,
    value: rawValue
  });
}
}

